import { format } from 'date-fns';

const formatCalendarDate = (date) => {
  const utcDate = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes());
  return format(utcDate, "yyyyMMdd'T'HHmmss'Z'");
};

export default formatCalendarDate;
